import ControlButton from '../controlButton.js';

import * as btnStyles from '../btn.module.scss';

export default class StartBtn extends ControlButton {
  constructor() {
    super({ text: 'START' });

    window.addEventListener('mouseup', this.handleStart.bind(this));
    window.addEventListener('changestart', this.handleChangeStart.bind(this));
  }

  /**
   * Sets the state's start property. Starts the game.
   * @returns {void}
   * @private
   */
  handleStart() {
    if (this.isPressed) this.state.start = true;
  }

  /**
   * Handles changes in the state's start property.
   * @param {CustomEvent<Partial<StateObj>>} e
   * @returns {void}
   * @private
   */
  handleChangeStart(e) {
    const { start } = e.detail;

    if (start) this.addClasses(btnStyles.btnHidden);
    else this.removeClasses(btnStyles.btnHidden);
  }
}
